/* eslint-disable */
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import LeavepageService from '../../../services/leave-page.service';

export const useSubmitLeave = (): UseMutationResult<any, Error, { leave: FormData }, void> =>
  useMutation((data: { leave: FormData }) => LeavepageService.submitLeave(data.leave), {
    onSuccess: () => {
      AlertAdapter('Leave request submitted successfully.', 'success');
    },
    onError: (error: Error) => {
      AlertAdapter(error.message, 'error');
    },
  });

export const useReSubmitLeave = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ leaveId, leave }: { leaveId: string; leave: FormData }) => LeavepageService.reSubmitLeave(leaveId, leave),
    {
      onSuccess: (_, variables) => {
        // ✅ variables = { leaveId, leave }
        AlertAdapter('Leave request re-submitted successfully.', 'success');
        queryClient.invalidateQueries({ queryKey: ['leave-balance'] });
        queryClient.invalidateQueries({ queryKey: ['leave/mine'] });
        queryClient.invalidateQueries({
          queryKey: ['leave-details', variables.leaveId], // ✅ Access via variables.leaveId
        });
      },
      onError: (error: Error) => {
        AlertAdapter(error.message, 'error');
      },
    }
  );
};
